<template>
    <section>
        <div class="page-wrap">
            <div class="main-container symbols-page">
                <div class="box-content">
                    <div class="box-content-inner">
                        <h2 class="main-headline">YOUR PROJECT. YOUR VISION.</h2>
                        <p class="subheadline">
                            With over 30+ years of experience, Fund Raisers, Ltd. has hand selected each product to
                            <br/> ensure that you receive only the best in the industry.
                        </p>

                        <router-link tag="a" class="back-button" to="/products">
                            Back to products
                        </router-link>

                        <h6 class="headline-sm">SYMBOLS, GREEK CHARACTERS & CUSTOM LOGOS</h6>
                        <p>
                            In addition to the standard characters allowed, Fund Raisers, Ltd. allows small and large symbols,
                            <br/> Greek characters, and custom logos to be engraved.
                        </p>
                        <div class="symbols">
                            <div class="symbols-left">
                                <div class="small-symbols">
                                    <p><strong>Small Symbol Options</strong> (.5”) use 2 character spaces</p>
                                    <img src="images/Products-Page/symbols1.png" alt="">
                                </div>
                                <div class="large-symbols">
                                    <p><strong>Large Symbol Options</strong> (1”) use 1 line of text</p>
                                    <img src="images/Products-Page/symbols2.png" alt="">
                                </div>
                                <div class="greek-symbols">
                                    <p><strong>Greek Characters</strong> (.5”) use 2 character spaces</p>
                                    <img src="images/Products-Page/symbols3.png" alt="">
                                </div>
                                <div class="custom-logo">
                                    <strong>Custom Logo</strong>
                                    <p>
                                        Add aesthetic value to your bricks for corporate sponsors
                                        and high-level donations with custom artwork and logos!
                                    </p>
                                </div>
                            </div>
                            <div class="symbols-right">
                                <img src="images/Products-Page/symbolssmall.png" alt="">
                                <span>Small Symbol</span>
                                <img src="images/Products-Page/symbolslarge.png" alt="">
                                <span>Large Symbol</span>
                                <img src="images/Products-Page/symbolsgreek.png" alt="">
                                <span>Greek Characters</span>
                                <img src="images/Products-Page/symbolscustom.png" alt="">
                                <span>Custom Logo</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'fonts',
        metaInfo: {
            title: 'Symbols',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'In addition to the standard characters allowed, Fund Raisers, Ltd. allows small and large symbols, Greek characters, and custom logos to be engraved.'
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// Symbols.vue?9f214fc0